import React from 'react'; 
import { render } from '@react-email/render';
import SCNEmailBodyTemplate from '../templates/email/SCNTemplate';
import ROEmailBodyTemplate from '../templates/email/ROTemplate';
import FICEmailBodyTemplate from '../templates/email/FICTemplate';
import { htmlToPlainTextMailto } from './mailtoGenerator';


const LEGAL_DISCLAIMER = `
CONFIDENTIALITY NOTICE: This email and any attachments are for the exclusive and confidential use of the intended recipient. If you are not the intended recipient, please do not read, distribute, or take action based on this message. Instead, please notify the sender immediately and delete all copies. This communication may be protected by attorney-client privilege or other legal privileges.

This email may contain confidential and/or privileged information. If you have received this email in error, please notify the sender immediately and delete this email. Any unauthorized copying, disclosure, or distribution of the material in this email is strictly prohibited.
`.trim();


export const renderSCNEmailBody = async (
  content: string,
  signature: string
): Promise<string> => {

  const htmlBody = await render(
    <SCNEmailBodyTemplate 
      content={content} 
      signature={signature} 
      footerNotice={LEGAL_DISCLAIMER} 
    />
  );
  
  // When we send emails using a 3rd party service, we'll remove this since they support rich HTML content
  // MailTo supports plain text only.
  return htmlToPlainTextMailto(htmlBody);
};


export const renderROEmailBody = async (
  content: string,
  signature: string
): Promise<string> => {

  const htmlBody = await render(
    <ROEmailBodyTemplate 
      content={content} 
      signature={signature} 
      footerNotice={LEGAL_DISCLAIMER} 
    />
  );
  
  // When we send emails using a 3rd party service, we'll remove this since they support rich HTML content
  // MailTo supports plain text only.
  return htmlToPlainTextMailto(htmlBody);
};


export const renderFICEmailBody = async (
  content: string,
  fraudClassification: string,
  signature: string
): Promise<string> => {

  const htmlBody = await render(
    <FICEmailBodyTemplate 
      content={content} 
      fraudClassification={fraudClassification}
      signature={signature} 
      footerNotice={LEGAL_DISCLAIMER} 
    />
  );
  
  // When we send emails using a 3rd party service, we'll remove this since they support rich HTML content
  // MailTo supports plain text only.
  return htmlToPlainTextMailto(htmlBody);
};
